
import Error from "../utils/Error";
import Loader from "../utils/Loader";
import { useNewsletters } from "../../hooks/useNewsLetter";
import ImageWithSkeleton from "../utils/imgSkeleton";

const Newsletter2 = () => {

  const { data:newsLetters, isLoading, error } = useNewsletters();


  if (isLoading) return <Loader />;

  if (error)
    return <Error message={error ? error.message : "Error Loading NewsLetter"} />;

  return (
    <div className="2xl:container w-full flex flex-col px-6 md:px-[70px]">
      <div className="flex flex-col gap-6 md:gap-12">
        {newsLetters?.data?.map((item, i) => (
          <>
            <div className="grid grid-cols-1 md:grid-cols-[2.3fr_1fr]">
              <div className="text-left">
                <div className="flex flex-col gap-3 md:gap-4 mb-6  sm:w-[80%] md:w-10/12">
                  <p className="text-14 md:text-20 font-medium text-[#046353]">
                    {item.title.toUpperCase()}
                  </p>
                  <p className="text-20 md:text-36 font-[700] text-headingtext">
                     {`“${item.heading.toUpperCase()}”`}
                  </p>
                  <p className="text-16 text-[#41444B] ">
                    {item.description1}
                  </p>
                  <p className="text-16 text-[#41444B] hidden md:block">
                    {item.description2}
                  </p>
                </div>
                <div className="flex text-14 md:text-16 text-headingtext font-medium gap-10 max-md:mb-10">
                  <p>{item.location}</p>
                </div>
                <div className="md:block hidden mt-6">
                   <a
                download
                href={item.pdf}
                target="_blank"
                className="text-14 md:text-20 font-medium text-[#046353]"
              >
                Download Newsletter
              </a>
                </div>
              </div>

              <a href={item.pdf} target="_blank" download className="cursor-pointer">
                <ImageWithSkeleton src={item.img} alt="image" containerClass="w-[350px] h-[250px]" />
              </a>
            </div>

            <div className="block flex flex-col md:hidden text-14 md:text-16 text-headingtext font-medium flex items-start">
              <p>{item.date}</p>
            </div>

            <div className="text-left md:hidden">
              <a
                download
                href={item.pdf}
                target="_blank"
                className="text-14 font-medium text-[#046353]"
              >
                Download Newsletter
              </a>
            </div>
           {i !== newsLetters.data.length - 1 && (
              <hr className="h-[1px]  text-[#CED0D6]" />
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default Newsletter2;
